export default __webpack_public_path__ + "static/media/2156.f3c1bfba.png";